export default class Piece {
  constructor(color, isKing = false) {
    this.color = color;
    this.isKing = isKing;
  }
}
